export const environment = {
  production: false,
  ENV: 'qa',
  FKEY: 'qF1C2B1F1rA1C7C7C4E1D4B3E1A9C6ekzG3C-8qrpmA-13E4aaskagaxcaH-9H-9yI-7C-22d1D2vyz==',
  BASEDOMAIN: 'qa-api.edulinksolutions.com',
  PORT: '',
  BASEURI: 'https://qa-api.edulinksolutions.com',
  ASSETSURI: 'https://qa-paetep.edulinksolutions.com',
  FIREBASECONFIG: {
    apiKey: "AIzaSyC6Oyps1jsm38LpaAEMHiq4KapSZJZZ5ls",
    authDomain: "edl-identity.firebaseapp.com"
  },
  FIREBASE_TENANT: ""
};
